import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Store } from '@src/store';
import { projectActions } from '@src/store/reducers/projectReducer';
import { DialogManagerService } from '@src/services';
import lodash from 'lodash';

@Component({
    selector: 'schemas-repository',
    template: require('./rotate-schemas-repository.component.html'),
    styles: [require('./rotate-schemas-repository.component.scss')]
})

export class RotateSchemasRepositoryComponent {

    @Input() public currEnvTypeIndex;
    // tslint:disable-next-line:variable-name
    @Input() public set currEnvironmentType(value) {
        if (this.schemasRepository != null) {
            this.schemasRepository.forEach(i => i.selected = false);
        }
        this._currEnvironmentType = value;
        this.updateSchemasState();
    };
    // tslint:disable-next-line:variable-name
    @Input() public set schemasRepository(value) {
        if (!this.hosts) {
            this.hosts = [];
        }
        if (value) {
            this._schemasRepository = value;
            if (this.lastConSettings) {
                this.lastConSettings.serverKey = `${this.lastConSettings.host}:${this.lastConSettings.port}`;
                // todo remove lodash
                this.unmangeConSettingsList = lodash.uniqBy(
                    this.unmangeConSettingsList.push(this.lastConSettings), 'serverKey');
            }
            const tmpHost = [];
            this._schemasRepository.forEach((item) => {
                item.connectionProperties.serverKey =
                    `${item.connectionProperties.host}:${item.connectionProperties.port}`;
                tmpHost.push(item);
            });
            // todo remove lodash
            const tmp = lodash.uniqBy(tmpHost, 'connectionProperties.serverKey');
            this.hosts = lodash.uniqBy([...tmp, ...this.hosts], (item) => {
                return [item.isManaged, item.connectionProperties.serverKey].join();
            });
            let isExist = false;
            this.unmangeSchemasByHostList.forEach((item, index) => {
                item.forEach((elem) => {
                    elem.connectionProperties.serverKey =
                        `${elem.connectionProperties.host}:${elem.connectionProperties.port}`;
                });
                if (item.length > 0 && this._schemasRepository.length > 0
                    && item[0].connectionProperties.serverKey ===
                    this._schemasRepository[0].connectionProperties.serverKey
                    && item[0].isManaged === this._schemasRepository[0].isManaged) {
                    this.unmangeSchemasByHostList[index] = Object.assign(this._schemasRepository);
                    isExist = true;
                }
            });
            if (!isExist && this._schemasRepository.length > 0) {
                this.unmangeSchemasByHostList.push(Object.assign(this._schemasRepository));
                this.selectedHost = this.hosts[0];
            }
            this.updateSchemasState();
        }
    };
    @Input() public projectData;
    @Output() public onAssignSchema = new EventEmitter<any>();
    @Output() public onChangeHost = new EventEmitter<any>();
    @Output() public onAddUnmanagedSchemas = new EventEmitter<any>();
    public unmangeConSettingsList: any[];
    public unmangeSchemasByHostList: any[];
    public _schemasRepository:any;
    public hosts: any[];
    public _currEnvironmentType:any;
    public databaseType: string;
    private isRMmustBeManage: boolean = false;
    private htmlConn: string;
    public dataT:any;
    public lastConSettings: any;
    private selectedHost: any;
    private lastSelectedHost: any;
    public refreshingSchemeRepository: boolean = false;
    public schemaFilter: string;

    constructor(private store: Store,
                @Inject('$state') public state: any,
                @Inject('$filter') public $filter: any,
                private dialogManagerService: DialogManagerService
    ) {
        this.unmangeConSettingsList = [];
        this.unmangeSchemasByHostList = [];
        this.hosts = [];
        this.dataT = this.$filter('dbTypeItem')(["Schemas"], this.state.params.dbType) 
        this.databaseType = this.state.params.dbType;
        // || window.dbTypeId.toString();
    }

    ngOnOnit(){
        this.store.dispatch({ type: projectActions.IS_RM_MANAGE_BY_DBTYPE, payload: { dbTypeId: this.databaseType } })
            .then(res => this.isRMmustBeManage = res);
        this.store.dispatch({
            type: projectActions.GET_AVAILABLE_SCHEMAS,
            payload: { project: this.projectData, dbID: this.databaseType }
        });
    }

    public addUnManagedPopup(): void {
        if(this.databaseType == undefined){
            //this.databaseType =  this.projectData.dbTypeId
            this.databaseType =  this.store.getState().project.data.dbTypeId.toString()
        }
        delete this.store.getState().schemas.status_test_schema;
        this.store.dispatch({
            type: 'GET_CONN_TEMPLATE',
            payload: { dbTypeId: this.databaseType, manageOrUnmanage: 'unmanaged' }
        }).then((res) => {
            this.htmlConn = res.htmlTemplate;
            this.dialogManagerService.showDBConnectionDialog(
                this.htmlConn,
                {
                    title: res.title,
                    buttons: [
                        {
                            text: 'OK', onClick: (instance, onClose) => {
                                this.handleDBTypeConnectionProperties(instance.data);
                                /*if (this.databaseType === '1') {
                                    delete instance.dataValue.connectionProperties.port;
                                    delete instance.dataValue.connectionProperties.identifierType;
                                    delete instance.dataValue.connectionProperties.identifier;
                                    instance.dataValue.connectionProperties.authType = instance.dataValue.authType.id;
                                }
                                */
                                onClose(instance.data);
                            }
                        },
                        {
                            text: 'Cancel', onClick: (_, onClose) => {
                                onClose();
                            }
                        }
                    ],
                    setData: (instance) => {
                        instance.data = {
                            connectionProperties: { host: '', userName: '', password: '' },
                            testButton: {
                                value: 'Test Connection', onClick: (data) => {
                                    this.handleDBTypeConnectionProperties(data);
                                    //if (this.databaseType === '1') {
                                    //    delete data.connectionProperties.port;
                                    //    delete data.connectionProperties.identifierType;
                                    //    delete data.connectionProperties.identifier;
                                    //    data.connectionProperties.authType = data.authType.id;
                                    //}
                                    data.status_test_schema = '';
                                    this.onAddUnmanagedSchemas.emit({ connectionProperties: data, isTest:true });
                                }
                            },
                            switchTab: (data, tab) => {
                                this.handleDBTypeConnectionProperties(data);
                                //if (this.databaseType === '1') {
                                //    delete data.connectionProperties.port;
                                //    delete data.connectionProperties.identifierType;
                                //    delete data.connectionProperties.identifier;
                                //    data.connectionProperties.authType = data.authType.id;
                                //}
                                if(!data.connectionProperties.lastVisit)
                                    data.connectionProperties.lastVisit = "Properties";
                                this.store.dispatch({
                                    type: 'SWITCH_TAB',
                                    payload: {
                                        dbTypeId: this.databaseType,
                                        connectionProperties: data.connectionProperties
                                    }
                                }).then((res) => {
                                    if (res) {
                                        data.connectionProperties = res;
                                        data.connectionProperties.lastVisit = tab;
                                    }
                                });
                            }
                        };
                    }
                },
                (data) => {
                    const schemaSettings = { ...data };
                    this.handleDBTypeConnectionProperties(schemaSettings);
                    //if (this.databaseType === '1') {
                    //    delete schemaSettings.connectionProperties.port;
                    //    delete schemaSettings.connectionProperties.identifierType;
                    //    delete schemaSettings.connectionProperties.identifier;
                    //    schemaSettings.authType = data.authType.id;
                    //}
                    this.lastConSettings = schemaSettings;
                    this.onAddUnmanagedSchemas.emit({ connectionProperties: schemaSettings, isTest : false});
                }
            );
        });
    }

    //Handle special connection string manipulation (TODO: should not be done in that class as this is a a generic handler)
    private handleDBTypeConnectionProperties(info:any)
    {
        if (this.databaseType === '1') {
            delete info.connectionProperties.port;
            delete info.connectionProperties.identifierType;
            delete info.connectionProperties.identifier;
            info.connectionProperties.authType = info.authType.id;
        }
    }


    public getSelectedSchemas() {
        return this.schemasRepository.filter(item => item.selected);
    }

    public updateSchemasState() {
        if (this.hosts) {
            this.hosts.forEach(host => host.isDisabledForThisSchema = false);
        }
        if (this._schemasRepository) {
            this._schemasRepository.forEach((item) => {
                item.isDisabledForThisSchema = item.isManaged === false && this.isCurrEnvironment();
            });
        }
        if (this.hosts && this.isCurrEnvironment()) {
            const unmanagedHosts = this.hosts.filter(host => !host.isManaged);
            if (unmanagedHosts) {
                unmanagedHosts.forEach(host => host.isDisabledForThisSchema = true);
            }
            const newHost = this.hosts.find(host => !host.isDisabledForThisSchema);
            if (newHost !== this.selectedHost) {
                this.selectedHost = newHost;
                this.onChangeHost.emit({ hostselected: this.selectedHost,
                    unmangeSchemasByHostList: this.unmangeSchemasByHostList });
            }
        }
    }

    public get schemasRepository() {
        return lodash.orderBy(this._schemasRepository, ['schemaName'], 'asc');
    }

    public schemasFilter = (schema) => {
        let valid = true;
        if (!schema) {
            valid = false;
        }
        if (this.schemaFilter != null && this.schemaFilter !== '') {
            if (!schema.schemaName.toLowerCase().includes(this.schemaFilter.toLowerCase())) {
                valid = false;
            }
        }
        if (this.selectedHost != null) {
            if (schema.connectionProperties.serverKey !== this.selectedHost.connectionProperties.serverKey) {
                valid = false;
            }
        }
        // // avoid selection of same unmanaged on diffrent env types
        let relevantTypes;
        if (this.projectData) {
            relevantTypes = this.projectData.environmentTypes;
        }
        if (relevantTypes) {
            relevantTypes.forEach((type) => {
                type.environments.forEach((env) => {
                    if (env.schemas) {
                        env.schemas.forEach((item) => {
                            if (item.connectionProperties.serverKey === schema.connectionProperties.serverKey
                                && item.schemaName === schema.schemaName // for oracle & ms-sql
                                && item.connectionProperties.identifier === schema.connectionProperties.identifier) {
                                valid = false;
                                return false;
                            }
                        });
                    }
                });
            });
        }
        return valid;
    }

    public refreshSchemeRepository() {
        if (!this.selectedHost || (this.selectedHost && this.selectedHost.isManaged === true)) {
            if (this.selectedHost) {
                this.lastSelectedHost = Object.assign(this.selectedHost);
            }
            this.refreshingSchemeRepository = true;
            this.store.dispatch({
                type: projectActions.GET_AVAILABLE_SCHEMAS,
                payload: { project: this.projectData, dbID: this.databaseType }
            }).then((resp) => {
                this.refreshingSchemeRepository = false;
                return resp;
            },      () => {
                this.refreshingSchemeRepository = false;
            });
            if (this.lastSelectedHost) {
                this.selectedHost = this.lastSelectedHost;
                setTimeout(() => {
                    this.selectedHost = Object.assign(this.lastSelectedHost);
                    this.onChangeHost.emit({
                        hostselected: this.lastSelectedHost,
                        unmangeSchemasByHostList: this.unmangeSchemasByHostList
                    });
                    // this.scope.$apply();
                    this.lastSelectedHost = null;
                },         150);
            }
        } else if (!this.isRMmustBeManage || this.currEnvironmentType.isRMSource === false) {
            this.addUnManagedPopup();
        }
    }

    private isCurrEnvironment(): boolean {
        return this.currEnvironmentType && this.currEnvironmentType.isRMSource
        && this.isRMmustBeManage && this.currEnvironmentType.environments
        && this.currEnvironmentType.environments.length === 1;
    }

    // rmHasVersion() {
    //     return this.currEnvironmentType && this.currEnvironmentType.isRMSource
    //         && this.currEnvironmentType.environments && this.currEnvironmentType.environments.length > 0
    //         && this.currEnvironmentType.environments[0].hasVersion;
    // }

    public isManageDisplayed(): boolean {
        return !this.isRMmustBeManage || !this.currEnvironmentType.isRMSource
            || (this.currEnvironmentType.isRMSource && this.currEnvironmentType.environments.length === 2);
    }

    // public refreshSchemeRepository() {
    //     console.log('refreshSchemeRepository');
    // }
    //
    // public addUnManagedPopup() {
    //     console.log('addUnManagedPopup');
    // }
    // public getSelectedSchemas() {
    //     console.log('getSelectedSchemas');
    // }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/environmentTypeRotator/rotatorItem/rotate-schemas-repository/rotate-schemas-repository.component.ts